import { render, staticRenderFns } from "./LinkedInSocial.vue?vue&type=template&id=4687d9ce&scoped=true&"
import script from "./LinkedInSocial.vue?vue&type=script&lang=js&"
export * from "./LinkedInSocial.vue?vue&type=script&lang=js&"
import style0 from "./LinkedInSocial.vue?vue&type=style&index=0&id=4687d9ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4687d9ce",
  null
  
)

export default component.exports